
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund-cancellation-policy",
      function () {
        return require("private-next-pages/refund-cancellation-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund-cancellation-policy"])
      });
    }
  